import type {ChangeRequest} from 'api/types';
import type {Schemas} from 'api/dto.generated';
import {loadAllChangeRequestsForWork} from 'api/localStorage';
import {ebsApi} from 'store/ebsApi';
import {mapManualApprovalChangeRequestsDto} from './mappers';

export const metadataApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getChangeRequests: build.query<
      ChangeRequest[],
      {workId: string; eans: string[]},
      Schemas.ManualApprovalChangeRequestsDto
    >({
      query: ({eans}) =>
        `manualapproval/changerequest/ean?ean=${eans.join(',')}`,
      transformResponse: (response, _, arg) => {
        const backendCRs = mapManualApprovalChangeRequestsDto(
          arg.workId,
          response,
        );
        const localCRs = loadAllChangeRequestsForWork(arg.workId);
        return [...backendCRs, ...localCRs];
      },
    }),
  }),
});

export const {useGetChangeRequestsQuery} = metadataApi;
